"use client";

import { useEffect, useState } from "react";
import { getCookie } from "@/utils/cookie";
import loadGoogleAnalytics from "@/utils/google-analytics";
import { CookieConsentBanner } from "@/components/CookieConsentBanner";

export function CookieConsentHandler() {
  const [consent, setConsent] = useState<string | null>(null);
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    // Mark that we're on the client
    setIsClient(true);
    
    // Get the actual cookie value on the client
    const cookieValue = getCookie("korrero_cookie_consent");
    setConsent(cookieValue);
  }, []);

  useEffect(() => {
    if (consent === "true") {
      loadGoogleAnalytics();
    }
  }, [consent]);

  // Don't render anything until we're on the client to avoid hydration mismatch
  if (!isClient) {
    return null;
  }

  return (
    <CookieConsentBanner
      setConsent={setConsent}
      isOpen={!consent}
    />
  );
}